// Shares the editor state, live run results and actions with deeply nested
// builder components (trail cards, list rows, dialogs).
import { createContext, useContext } from "react";

export const BuilderContext = createContext(null);

export const useBuilder = () => {
  const context = useContext(BuilderContext);
  if (!context) throw new Error("useBuilder must be used inside the Workflow Builder");
  return context;
};
